export const state = {
  isOnline: true,
  latestResponseTimeInMilliseconds: null,
  networkStatus: []
};
